import bff from './bff'
import apiCallHandler from './apiCallHandler'

export const getBenefits = (site) => {
  return apiCallHandler(() => bff.get(`/register/operatorCard?site=${site}`))
}
